import React, { useState } from "react";
import MapView from "./MapView.jsx";
import SIIGSOLLegend from "./SIIGSOLLegend";
import AgricoleLegend from "./AgricoleLegend";
import IACLegend from "./IACLegend";
import LegendBDPPAMontere from "./LegendBDPPAMontere.jsx";
import LegendPanel from "./LegendPanel.jsx";
import ResizableSidebar from "./ResizableSidebar.jsx";
import AgricoleCustomLegend from "./AgricoleCustomLegend.jsx";

const tabs = [
  { key: "Carte interactive", label: "Carte interactive" },
  { key: "Données de sol", label: "Données de sol - TEST MODIF" },
  { key: "Données météo", label: "Données météo" },
  { key: "Données agricoles", label: "Données agricoles" }
];

const layersByTab = {
  "Carte interactive": [
    "Projet_MOS_Essai:Couverture_pedo_2022_Montere",
    "Projet_MOS_Essai:bdppa_montere",
    "Projet_MOS_Essai:Limite-montere",
    "Projet_MOS_Essai:Limites-MRC-Montere"
  ],
  "Données de sol": [
    "Projet_MOS_Essai:SIIGSOL_Argile_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_CEC_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_COrg_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_Limon_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_Sable_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_pH_MRC_MOS",
    "Projet_MOS_Essai:Zone_specifiq"
  ],
  "Données météo": [
    "Projet_MOS_Essai:meteo_data",
    "Projet_MOS_Essai:Limite-montere"
  ],
  "Données agricoles": [
    "Projet_MOS_Essai:BDPPAD_2015_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2016_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2017_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2018_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2019_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2020_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2021_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2022_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2023_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2024_MRC_MOS",
    "Projet_MOS_Essai:IAC-2015_MRC",
    "Projet_MOS_Essai:IAC-2016_MRC",
    "Projet_MOS_Essai:IAC-2017_MRC",
    "Projet_MOS_Essai:IAC-2018_MRC",
    "Projet_MOS_Essai:IAC-2019_MRC",
    "Projet_MOS_Essai:IAC-2020_MRC",
    "Projet_MOS_Essai:IAC-2021_MRC",
    "Projet_MOS_Essai:IAC_2022_MRC",
    "Projet_MOS_Essai:IAC-2023_MRC",
    "Projet_MOS_Essai:IAC-2024_MRC"
  ]
};

export default function StevensX() {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const [activeLayer, setActiveLayer] = useState(layersByTab[activeTab][0]);
  const [visibleLayers, setVisibleLayers] = useState([layersByTab[activeTab][0]]);

  // Met à jour la couche et la superposition quand l’onglet change
  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setActiveLayer(layersByTab[tabKey][0]);
    setVisibleLayers([layersByTab[tabKey][0]]);
  };

  // Ajoute ou retire une couche de la superposition
  const handleLayerToggle = (layer) => {
    setActiveLayer(layer);
    setVisibleLayers((prev) =>
      prev.includes(layer)
        ? prev.filter(l => l !== layer)
        : [...prev, layer]
    );
  };

  return (
    <div className="container">
      <div className="tabs">
        {tabs.map(tab => (
          <button
            key={tab.key}
            className={activeTab === tab.key ? "active" : ""}
            onClick={() => handleTabChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="main-content">
        <div className="dashboard">
          <ResizableSidebar>
            {activeTab === "Données agricoles" ? (
              <div style={{ display: "flex", gap: "1em" }}>
                <div style={{ flex: 1 }}>
                  <h4>Liste des couches</h4>
                  <ul style={{ fontSize: "0.75em" }}>
                    {layersByTab[activeTab].map(layer => (
                      <li key={layer}>
                        <label style={{ display: "flex", alignItems: "center", gap: "0.5em" }}>
                          <input
                            type="checkbox"
                            checked={visibleLayers.includes(layer)}
                            onChange={() => handleLayerToggle(layer)}
                          />
                          <button
                            className={activeLayer === layer ? "active" : ""}
                            onClick={() => setActiveLayer(layer)}
                            style={{ marginLeft: "0.5em", fontSize: "0.85em", padding: "0.15em 0.5em" }}
                          >
                            {layer.split(":")[1] || layer}
                          </button>
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className="legend-window"
                  style={{
                    flex: 1,
                    minWidth: "220px",
                    maxWidth: "400px",
                    background: "#232b21",
                    color: "#fff",
                    borderRadius: "8px",
                    padding: "1em",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    overflowY: "auto"
                  }}
                >
                  <h4 style={{ color: "#bfcf7f" }}>Légende</h4>
                  {visibleLayers.length === 1 && activeLayer.startsWith("Projet_MOS_Essai:SIIGSOL_") && (
                    <SIIGSOLLegend layer={activeLayer} />
                  )}
                  {visibleLayers.length === 1 && activeLayer.startsWith("Projet_MOS_Essai:BDPPAD_") && (
                    <AgricoleLegend layer={visibleLayers[0]} />
                  )}
                  {visibleLayers.length === 1 && activeLayer.startsWith("Projet_MOS_Essai:IAC-") && (
                    <IACLegend layer={activeLayer} />
                  )}
                </div>
              </div>
            ) : activeTab === "Carte interactive" ? (
              <div style={{ display: "flex", gap: "1em" }}>
                <div style={{ flex: 1 }}>
                  <h4>Liste des couches</h4>
                  <ul style={{ fontSize: "0.75em" }}>
                    {layersByTab[activeTab].map(layer => (
                      <li key={layer}>
                        <label style={{ display: "flex", alignItems: "center", gap: "0.5em" }}>
                          <input
                            type="checkbox"
                            checked={visibleLayers.includes(layer)}
                            onChange={() => handleLayerToggle(layer)}
                          />
                          <button
                            className={activeLayer === layer ? "active" : ""}
                            onClick={() => setActiveLayer(layer)}
                            style={{ marginLeft: "0.5em", fontSize: "0.85em", padding: "0.15em 0.5em" }}
                          >
                            {layer.split(":")[1] || layer}
                          </button>
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className="legend-window"
                  style={{
                    flex: 1,
                    minWidth: "220px",
                    maxWidth: "400px",
                    background: "#232b21",
                    color: "#fff",
                    borderRadius: "8px",
                    padding: "1em",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    overflowY: "auto"
                  }}
                >
                  <h4>Légende</h4>
                  {/* Test d’affichage */}
                  <div style={{
                    background: "#2a4d1b",
                    color: "#fff",
                    borderRadius: "6px",
                    padding: "0.7em",
                    marginBottom: "1em",
                    textAlign: "center"
                  }}>
                    <b>Test :</b> Ceci s’affiche dans la fenêtre de légende.
                  </div>
                  {visibleLayers.includes("Projet_MOS_Essai:bdppa_montere") && (
                    <LegendPanel
                      layer={activeLayer}
                      visibleLayers={visibleLayers}
                    />
                  )}
                </div>
              </div>
            ) : (
              <>
                <h4>Liste des couches</h4>
                <ul>
                  {layersByTab[activeTab].map(layer => (
                    <li key={layer}>
                      <label style={{ display: "flex", alignItems: "center", gap: "0.5em" }}>
                        <input
                          type="checkbox"
                          checked={visibleLayers.includes(layer)}
                          onChange={() => handleLayerToggle(layer)}
                        />
                        <button
                          className={activeLayer === layer ? "active" : ""}
                          onClick={() => setActiveLayer(layer)}
                          style={{ marginLeft: "0.5em" }}
                        >
                          {layer.split(":")[1] || layer}
                        </button>
                      </label>
                    </li>
                  ))}
                </ul>
                <h4>Légende</h4>
                {activeTab === "Données de sol" && (
                  <SIIGSOLLegend layer={activeLayer} />
                )}
              </>
            )}
          </ResizableSidebar>
        </div>
        <div className="map-panel">
          <MapView activeLayer={activeLayer} visibleLayers={visibleLayers} />
        </div>
      </div>
    </div>
  );
}
